import { useTextSize } from '../context/TextSizeContext';
import { useLang } from '../context/LanguageContext';
import './TextSizeToggle.css';

const SIZES = ['sm', 'md', 'lg'];

export default function TextSizeToggle() {
  const { textSize, setTextSize } = useTextSize();
  const { t } = useLang();
  const idx = SIZES.indexOf(textSize);

  const stepDown = () => {
    if (idx > 0) setTextSize(SIZES[idx - 1]);
  };

  const stepUp = () => {
    if (idx < SIZES.length - 1) setTextSize(SIZES[idx + 1]);
  };

  return (
    <div className="text-stepper" role="group" aria-label={t.textSizeLabel}>
      <button
        type="button"
        className="text-stepper__btn text-stepper__btn--down"
        onClick={stepDown}
        disabled={idx === 0}
        aria-label={`${t.textSizeLabel}: smaller`}
      >
        −
      </button>
      <span className="text-stepper__label" aria-live="polite" title={t.textSizeLabel}>
        <span className="text-stepper__glyph">{t[`textSize_${textSize}`]}</span>
        <span className="text-stepper__hint">{t[`textSize_${textSize}_hint`]}</span>
      </span>
      <button
        type="button"
        className="text-stepper__btn text-stepper__btn--up"
        onClick={stepUp}
        disabled={idx === SIZES.length - 1}
        aria-label={`${t.textSizeLabel}: larger`}
      >
        +
      </button>
    </div>
  );
}
